module.exports = __webpack_public_path__ + "img/Israel.1e0a2734.svg";